import { ANALYTICS_ROUTE } from '~/routes/analytics';
import { API_ROUTES } from '~/routes/api';
import { CONFIRMATION_ROUTES } from '~/routes/confirmation';
import { CREATE_QR_ROUTES } from '~/routes/createQr';
import { ERROR_ROUTES } from '~/routes/errors';
import { LOGIN_ROUTES } from '~/routes/login';
import { MICROSITE_ROUTE } from '~/routes/microsite';
import { MY_QR_ROUTES } from '~/routes/myqr';
import { PAYMENTS_ROUTES } from '~/routes/payments';
import { QR_BUILDER_ROUTES } from '~/routes/qrBuilder';
import { SETTINGS_ROUTES } from '~/routes/settings';
import { TERMS_CONDITIONS_ROUTES } from '~/routes/terms';
import { UNAUTH_QR_ROUTES } from '~/routes/unAuthQr';

export const appRoutes = [
  LOGIN_ROUTES,
  UNAUTH_QR_ROUTES,
  MY_QR_ROUTES,
  SETTINGS_ROUTES,
  CREATE_QR_ROUTES,
  QR_BUILDER_ROUTES,
  CONFIRMATION_ROUTES,
  PAYMENTS_ROUTES,
  API_ROUTES,
  MICROSITE_ROUTE,
  TERMS_CONDITIONS_ROUTES,
  ERROR_ROUTES,
  ANALYTICS_ROUTE,
].flat();
